import { gql, TypedDocumentNode } from '@apollo/client'

import { ERROR_FRAGMENT } from 'providers/graphql'
import { Data, Variables } from './types'

export const UPDATE_PAAPI_PREBID_MODULE: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${ERROR_FRAGMENT}

  mutation updatePaapiPrebidModule($input: UpdatePaapiPrebidModuleInput!) {
    updatePaapiPrebidModule(input: $input) {
      workspacePrebidModule {
        id
        enabled
        params
        workspaceBidderIds
      }

      errors {
        ...ErrorFragment
      }
    }
  }
`
